import httpClient from './httpClient'

const descriptionSheets = {
    getList(params) {
        return httpClient.get(`/api/business-support/description-sheets`, { params }).then(
            response => response.success ? response.descriptionSheets : undefined
        )
    },
    getDescriptionSheetById(id) {
        return httpClient.get(`/api/business-support/description-sheets/${id}`).then(
            response => response.success ? response.descriptionSheet : undefined
        )
    }
}

export default descriptionSheets